import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import TianyanchaRecordCard from '../TianyanchaRecordCard'

interface AppbkItem {
  brief: string
  classes: string
  filterName: string
  name: string
  type: string
  uuid: string
}

interface Props {
  data: any
  title: string
  sectionIndex?: string
}

const normalizeItems = (items: AppbkItem[] = []) =>
  items.map((item) => ({
    name: item.name || '—',
    type: item.type || '—',
    classes: item.classes || '—',
    remark: item.brief || '—',
    filterName: item.filterName || '—',
  }))

export default function TianyanchaAppbkInfo({ data, title, sectionIndex }: Props) {
  let jsonData: any
  try {
    jsonData = JSON.parse(data.tianyancha_appbkInfo ?? '{}')
  } catch (error) {
    jsonData = {}
  }

  const products = normalizeItems(jsonData.items)
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          产品信息
        </Text>
        <Stack gap="sm" className="mt-3">
          {products.length === 0 ? (
            <Text c="dimmed" size="sm" ta="center">
              暂无产品信息
            </Text>
          ) : (
            products.map((item, index) => (
              <TianyanchaRecordCard
                key={`${item.name}-${index}`}
                number={index + 1}
                recordType="产品"
                fields={[
                  { label: '产品名称', value: item.name },
                  { label: '产品类型', value: item.type },
                  { label: '产品分类', value: item.classes },
                  { label: '产品概述', value: item.remark, span: 2 },
                ]}
              />
            ))
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
